import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBreadcrumbs } from '.';

function useUpdateBreadcrumbParam(paramName: string, value?: string | number) {
  const { pathname } = useLocation();
  const { setParamLabel } = useBreadcrumbs();

  useEffect(() => {
    if (value) {
      setParamLabel(paramName, value.toString());
    }
  }, [value, pathname]);
}

export default useUpdateBreadcrumbParam;
